import React from 'react';
import Icon from '../../../components/AppIcon';

const EnvironmentToggle = ({ environment, onEnvironmentChange }) => {
  const environments = [
    {
      id: 'sandbox',
      name: 'Sandbox',
      description: 'Safe testing environment with sample data',
      icon: 'TestTube',
      color: 'from-amber-500 to-orange-600',
      bgColor: 'bg-amber-50 dark:bg-amber-900/20',
      borderColor: 'border-amber-200 dark:border-amber-800',
      textColor: 'text-amber-700 dark:text-amber-300'
    },
    {
      id: 'production',
      name: 'Production',
      description: 'Live environment with real data processing',
      icon: 'Rocket',
      color: 'from-emerald-500 to-teal-600',
      bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
      borderColor: 'border-emerald-200 dark:border-emerald-800',
      textColor: 'text-emerald-700 dark:text-emerald-300'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground mb-1">
          Deployment Environment
        </h3>
        <p className="text-sm text-text-secondary">
          Choose where to deploy your agent
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-3 max-w-2xl mx-auto">
        {environments?.map((env) => {
          const isSelected = environment === env.id;
          
          return (
            <button
              key={env.id}
              onClick={() => onEnvironmentChange(env.id)}
              className={`flex-1 p-4 rounded-xl border-2 transition-all duration-300 ${
                isSelected
                  ? `${env.bgColor} ${env.borderColor} shadow-lg`
                  : 'bg-card border-border hover:border-muted-foreground/30'
              }`}
            >
              <div className="flex items-center space-x-3">
                <div className={`w-10 h-10 bg-gradient-to-br ${env.color} rounded-lg flex items-center justify-center flex-shrink-0 ${
                  isSelected ? 'animate-pulse-soft' : ''
                }`}>
                  <Icon 
                    name={env.icon} 
                    size={20} 
                    color="white" 
                    strokeWidth={2}
                  />
                </div>
                
                <div className="flex-1 text-left">
                  <div className="flex items-center space-x-2">
                    <h4 className={`font-semibold ${
                      isSelected ? env.textColor : 'text-card-foreground'
                    }`}>
                      {env.name}
                    </h4>
                    {isSelected && (
                      <Icon 
                        name="CheckCircle" 
                        size={16} 
                        className={env.textColor}
                      />
                    )}
                  </div>
                  <p className={`text-sm ${
                    isSelected ? env.textColor : 'text-text-secondary'
                  }`}>
                    {env.description}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      {environment === 'production' && (
        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 max-w-2xl mx-auto animate-fade-in">
          <div className="flex items-start space-x-3">
            <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
            <div>
              <h4 className="font-medium text-warning mb-1">
                Production Environment Warning
              </h4>
              <p className="text-sm text-warning/80">
                You are deploying to the live production environment. This will process real data and may incur charges based on your usage plan.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvironmentToggle;